import * as yup from 'yup';

const givenName = {
  base: yup.string().typeError('errorMessages.string')
};
givenName.required = givenName.base.required('errorMessages.required');
givenName.optional = givenName.base;

export default givenName;
